import {openResourceModal} from '../../core/modalCommand';
import {
	SWITCH_IPV4_ACL_CREATE_MODAL_EVENT,
	SWITCH_IPV4_ACL_DELETE_MODAL_EVENT,
	SWITCH_IPV4_ACL_ADD_ACE_EVENT,
	SWITCH_IPV4_ACL_EDIT_ACE_EVENT,
	SWITCH_IPV4_ACL_DELETE_ACE_EVENT,
} from './events';

/**
 * Open Add Switch IPv4 ACL.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv4AclCreateModal(command, envelope) {
	return openResourceModal(SWITCH_IPV4_ACL_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete Switch IPv4 ACL.
 *
 * The confirmation, not the deletion. Nothing is removed until
 * the person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv4AclDeleteModal(command, envelope) {
	return openResourceModal(SWITCH_IPV4_ACL_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open the form for a new rule inside one SwitchIpv4Acl.
 *
 * A rule belongs to an ACL, so the ACL is named first and the form opens
 * against it. Nothing is saved here.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv4AclAddAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV4_ACL_ADD_ACE_EVENT, command, envelope);
}

/**
 * Open one existing rule for editing.
 *
 * Which rule is the sequence the request supplied; the ACL around it is the
 * resolved entity.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv4AclEditAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV4_ACL_EDIT_ACE_EVENT, command, envelope);
}

/**
 * Open the confirmation for deleting one rule.
 *
 * The rule, never the ACL around it. The confirmation is where it stops.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv4AclDeleteAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV4_ACL_DELETE_ACE_EVENT, command, envelope);
}
